module.exports = __webpack_public_path__ + "media/images/linkedin-7e3fde67dc51eeb12e86326b2b73a15a.svg";